import useGetLoadingSpinnerColor from "../../Hooks/useGetLoadingSpinnerColor.tsx"

const LoadingSpinner = ({ width = 3, height = 3, bubble = true, fullScreenLoading = false, loadingText = '' }) => {
    const { getSpinnerColor } = useGetLoadingSpinnerColor()

    const formattedWidth = `${width}rem`
    const formattedHeight = `${height}rem`
    const spinnerColor = getSpinnerColor()
    const spinnerStyle = bubble ? `spinner-grow ${spinnerColor} mb-5 mt-5` : `spinner-border ${spinnerColor}`

    if (fullScreenLoading) {
        return (
            <div className="row vh-100 align-items-center justify-content-center" style={{ overflow: 'hidden' }}>
                <div className="d-flex flex-column align-items-center">
                    <span className="text-center mb-1">{loadingText}</span>
                    <div className={spinnerStyle} role="status" />
                </div>
            </div>
        )
    }
    else {
        return (
            <div className='d-flex flex-column align-items-center'>
                <span className='mt-3 text-center'>{loadingText}</span>
                <div className={spinnerStyle} role="status" style={{ width: formattedWidth, height: formattedHeight }} />
            </div>
        )
    }
}

export default LoadingSpinner